<template>
  <b-row class="px-1">
    <b-col cols="8">
      <div class="d-flex w-100 mb-2">
        <div class="inventory-label">
          Reference
        </div>
        <b-form-input
          class="w-70"
          id="ref-privilege"
          placeholder="Reference"
          v-model="reference"
          disabled
        />
      </div>
      <div class="d-flex w-100 mb-2">
        <div class="inventory-label">
          Name(EN)
        </div>
        <b-form-input
          class="w-70"
          id="ref-privilege"
          placeholder="Reference"
          v-model="nameEn"
          disabled
        />
      </div>
      <div class="d-flex w-100 mb-2">
        <div class="inventory-label">
          Name(TH)
        </div>
        <b-form-input
          class="w-70"
          id="ref-privilege"
          placeholder="Reference"
          v-model="nameTh"
          disabled
        />
      </div>
    </b-col>
    <b-col cols="4" class="d-flex justify-content-end">
      <img-preview-content :imageUrl="imageUrl"/>
    </b-col>
  </b-row>
</template>

<script>
import ImgPreviewContent from './ImgPreviewContent.vue';
export default {
  props: {
    reference: { type: String, default: "" },
    // namePrivilege: { type: String, default: "" },
    nameEn: { type: String, default: "" },
    nameTh: { type: String, default: "" },
    imageUrl: { type: String, default: "" },
  },
  components: { ImgPreviewContent },
};
</script>

<style scoped>
@import "~@/assets/css/pages/inventory/history-privilege-detail.css";
</style>
